window.Yext = window.Yext || {};
import 'babel-polyfill';

import { Global } from 'js/common/global.js';
import { OnReady } from 'js/components/Util/Browser.js';
import { InitSoy2JS } from 'js/components/Soy2js/Soy2js.js';
import { GoogleAdwords } from 'js/components/GoogleAdwords/index.js'; 
import { GoogleAnalytics } from 'js/components/GoogleAnalytics/index.js';

InitSoy2JS(window.Yext);

Global.init();
GoogleAdwords.init();
GoogleAnalytics.enableAutotracking('yext');

OnReady(() => {
});
